export default "__VITE_ASSET__CBQ3yDYy__"